namespace $.$$ {
	export class $shm_hitalama_draglist extends $.$shm_hitalama_draglist {

		@ $mol_mem
		items() {
			return this.ids().map( id => this.Drag( id ) )
		}

		@ $mol_mem
		some_dragged(): boolean {
			return this.ids().some( id => this.dragged(id) )
		}

		id( id: any ): string {
			return id
		}

		_last_dragged?: {
			id: string,
			start_event: PointerEvent,
			end_event?: PointerEvent,
		}
		on_drag_start( id: any, next: PointerEvent ) {
			this._last_dragged = {
				id,
				start_event: next,
			}
		}
		on_drag_end( id: any, next?: PointerEvent ) {
			this._last_dragged!.end_event = next
		}
		
	}

}
